import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const ClassFormDialog = ({ open, onOpenChange, editingClass, formData, setFormData, onSubmit }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border">
        <DialogHeader>
          <DialogTitle>{editingClass ? 'Edit Class' : 'Create Class'}</DialogTitle>
          <DialogDescription className="sr-only">
            {editingClass ? 'Edit the class name, year and school.' : 'Create a new class with name, year and school.'}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label htmlFor="name">Class Name</Label>
            <Input
              id="name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="e.g., 3A"
              required
              className="bg-background border-border"
              data-testid="class-name-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="year">Year</Label>
            <Input
              id="year" type="number"
              value={formData.year}
              onChange={(e) => setFormData({ ...formData, year: parseInt(e.target.value) })}
              required
              className="bg-background border-border"
              data-testid="class-year-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="school">School Name</Label>
            <Input
              id="school"
              value={formData.school_name}
              onChange={(e) => setFormData({ ...formData, school_name: e.target.value })}
              placeholder="e.g., Primary School Zurich"
              required
              className="bg-background border-border"
              data-testid="school-name-input"
            />
          </div>
          <Button type="submit" className="w-full bg-primary hover:bg-primary/90" data-testid="save-class-btn">
            {editingClass ? 'Update Class' : 'Create Class'}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
